import { render, staticRenderFns } from "./UiReadMore.vue?vue&type=template&id=2688a999&scoped=true&"
import script from "./UiReadMore.vue?vue&type=script&lang=js&"
export * from "./UiReadMore.vue?vue&type=script&lang=js&"
import style0 from "./UiReadMore.vue?vue&type=style&index=0&id=2688a999&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688a999",
  null
  
)

export default component.exports